import { Outlet } from "react-router-dom";

import Footer from "./Portal/footer";

const Portal = () => (
  <div className="relative -z-0 flex h-full min-h-screen flex-col bg-neutrals-light-sand   bg-cover bg-ms-bg bg-center">
    {/* <TopMenu /> */}
    <Outlet />

    <Footer />
  </div>
);

export default Portal;
